import React, { FC, useState } from 'react';
import { useGetPayload } from '~/controllers/wizard';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import IndividualTable, {
  getIndividualsData,
} from '~/pages/ksa/application/shareholders/components/individuals/IndividualTable';
import IndividualReview from './IndividualReview';

const IndividualReviewTableForm: FC<Partial<FormItemInjectedProps<KsaShareholders>>> = (props) => {
  const payload = useGetPayload();
  const shareholders = { shareholders: payload?.shareholders };

  const [editUid, setUid] = useState('');
  const openEdit = (uid: string) => {
    setUid(uid);
  };
  const closeEdit = () => {
    setUid('');
  };

  const individualDataSource = getIndividualsData(shareholders, openEdit);

  return (
    <>
      {editUid && <IndividualReview uid={editUid} onClose={closeEdit} {...props} />}
      <IndividualTable individuals={individualDataSource} />
    </>
  );
};

export default IndividualReviewTableForm;
